import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'
import { store } from '@/store'
import router from './router'
import Vuex from 'vuex'
import 'bootstrap/dist/css/bootstrap.css'
import 'es6-promise/auto'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ThemifyIcon from "vue-themify-icons";
import VueAnalytics from 'vue-analytics';
import VueDragscroll from 'vue-dragscroll'
import Snackbar from 'vuejs-snackbar';
 
// Global register
Vue.component('snackbar', Snackbar);
Vue.use(VueDragscroll)
Vue.use(VueFormWizard);
Vue.use(ThemifyIcon);

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-187675491-1',
  router
});

Vue.directive('click-outside', {
  bind () {
      this.event = event => this.vm.$emit(this.expression, event)
      this.el.addEventListener('click', this.stopProp)
      document.body.addEventListener('click', this.event)
  },   
  unbind() {
    this.el.removeEventListener('click', this.stopProp)
    document.body.removeEventListener('click', this.event)
  },

  stopProp(event) { event.stopPropagation() }
})

import { library } from '@fortawesome/fontawesome-svg-core'
import { faImage, faBan, faCarSide, faMobile, faSearch, faCheck, faCartPlus, faCreditCard, faMoneyBillWave, faChevronLeft, faChevronUp, faChevronDown, faPlusSquare, faMinusSquare, faShoppingCart, faInfoCircle, faMapMarkedAlt, faChevronRight, faTimes, faEdit, faPrint, faBars, faColumns, faHouseUser, faArrowRight, faPlus, faBuilding, faEnvelope, faPaperPlane, faStar, faSortDown, faSortUp, faCircle, faBookmark, faComment, faPhone, faCog, faFilter, faMinus} from '@fortawesome/free-solid-svg-icons'
import { faCcPaypal, faCcVisa,faFacebookSquare, faTwitter, faWhatsapp, faInstagram, faWordpress} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './registerServiceWorker'

library.add(faMinus, faImage, faBan, faCarSide, faMobile, faSearch, faCheck, faCartPlus, faCcPaypal, faCcVisa, faCreditCard, faMoneyBillWave, faChevronLeft, faChevronUp,faChevronDown, faPlusSquare, faMinusSquare, faShoppingCart, faInfoCircle, faMapMarkedAlt, faChevronRight, faTimes, faEdit, faCog, faFilter, faPrint, faBars, faColumns, faHouseUser, faArrowRight, faPlus, faBuilding, faEnvelope, faFacebookSquare, faPaperPlane, faTwitter, faWhatsapp, faSortUp, faSortDown, faStar, faCircle, faBookmark, faComment, faInstagram, faWordpress, faPhone)

const moment = require('moment')
require('moment/locale/de')
 
Vue.use(require('vue-moment'), {
    moment
})

import VueMeta from 'vue-meta'
 
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuex)
Vue.use(BootstrapVue)


Vue.config.productionTip = false
Vue.config.silent = true

new Vue({
  router,
  store,
  created: function(){
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    // (function(d,s,id){
    //   var js
    //   var fjs = d.getElementsByTagName(s)[0]
    //   if(d.getElementById(id)) return
    //   js = d.createElement(s)
    //   js.id = id
    //   js.src = 'src="https://connect.facebook.net/en_US/sdk.js"'
    //   fjs.parentNode.instertBefore(js, fjs)
    // }(document, 'script', 'facebook-jssdk')
    // )
  },
  // components: {
  //   QrcodeVue,
  // },
  render: h => h(App)
}).$mount('#app')
